import { useEffect } from "react";
import { useLocation } from "react-router";

// document.referrer never changes across SPA navigations, so it is only
// sent with the first page view of a load; later views are internal.
let firstView = true;

/**
 * Report each public page view to the visit log. Static pages never reach
 * the Worker on their own, so without this nothing would be counted.
 */
export function useVisitBeacon() {
  const { pathname } = useLocation();

  useEffect(() => {
    const referrer = firstView ? document.referrer : undefined;
    firstView = false;
    void fetch("/api/visit", {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: pathname, referrer }),
    }).catch(() => undefined);
  }, [pathname]);
}
